export default {
  path: '/standingBook',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'businessStatement',
      name: 'businessStatement',
      component: () => import('@/pages/standingBook/businessStatement/index.vue'),
      meta: {
        keepAlive: true,
        title: '业务明细表',
      },
    },
    {
      path: 'overdueReminder',
      name: 'overdueReminder',
      component: () => import('@/pages/standingBook/overdueReminder/index.vue'),
      meta: {
        keepAlive: true,
        title: '逾期提醒',
      },
    },
    {
      path: 'verificationIncome',
      name: 'verificationIncome',
      component: () => import('@/pages/standingBook/verificationIncome/index.vue'),
      meta: {
        keepAlive: true,
        title: '收益明细表规则验证',
      },
    },
    {
      path: 'fundPossession',
      name: 'fundPossession',
      component: () => import('@/pages/standingBook/fundPossession/index.vue'),
      meta: {
        keepAlive: true,
        title: '资金占用费',
      },
    },
    {
      path: 'liquidatedDamages',
      name: 'liquidatedDamages',
      component: () => import('@/pages/standingBook/liquidatedDamages/index.vue'),
      meta: {
        keepAlive: true,
        title: '违约金收取台账',
      },
    },
    {
      path: 'overdueDetailReport',
      name: 'overdueDetailReport',
      component: () => import('@/pages/standingBook/overdueDetailReport/index.vue'),
      meta: {
        keepAlive: true,
        title: '逾期明细表',
      },
    },
    // {
    //   path: {
    //     path: 'overdueDetail',
    //     name: 'overdueDetail',
    //     component: () => import('@/pages/standingBook/overdueDetail/over.vue'),
    //     meta: {
    //       keepAlive: true,
    //       title: '逾期明细表',
    //     },
    //   },
    // },
  ],
};
